export default __webpack_public_path__ + "static/media/DNo.15-0.48c8c66c.jpg";